import { render, staticRenderFns } from "./dimensionModal.vue?vue&type=template&id=575e83ac&scoped=true"
import script from "./dimensionModal.vue?vue&type=script&lang=js"
export * from "./dimensionModal.vue?vue&type=script&lang=js"
import style0 from "./dimensionModal.vue?vue&type=style&index=0&id=575e83ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575e83ac",
  null
  
)

export default component.exports